import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { listDocumentoSueldoSitioWeb } from '@/api/municipalidadAPI';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { URL_ADJUNTOS } from '../constants/constants';
import { BoxArrowInUpRight } from 'react-bootstrap-icons';
import './SueldosView.css';

const SueldosView = () => {
  const [sueldos, setSueldos] = useState(null);

  useEffect(() => {
    listDocumentoSueldoSitioWeb()
      .then((response) => {
        setSueldos(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Sueldos"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <h7 className="sueldos-title">Puede descargar los Sueldos en los siguientes enlaces.</h7>
        {sueldos !== null &&
          sueldos.length > 0 &&
          sueldos.map((item, idx) => (
            <div key={idx}>
              <a
                rel="noreferrer"
                target="_blank"
                className="sueldo-link"
                href={URL_ADJUNTOS + '?id=' + item.documento.id}
              >
                {item.periodoSueldoAsString + ' ' + item.anioDocumentoAsString}{' '}
                <BoxArrowInUpRight />
              </a>
            </div>
          ))}
      </Container>
    </>
  );
};

export default React.memo(SueldosView);
